var $99d0adf4dd510366$exports = {};
$99d0adf4dd510366$exports = {
    "loading": `Notiek iel\u{101}de...`,
    "loadingMore": `Tiek iel\u{101}d\u{113}ts v\u{113}l...`
};


export {$99d0adf4dd510366$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
